var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 34,
    viewBox: "0 0 5.8208 8.9958",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43.225 -149.08)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47.551 153.49c-0.80542 0.61479-0.4132 1.4768 0.06567 1.7668 0.68136 0.4132 0.75707 1.5853-0.02007 1.8881-0.89116 0.34661-1.038-0.10672-1.6592-0.32746-0.26634-0.094-0.82913 0.0456-1.3554-0.52995-0.31651-0.3457-0.41594-0.9021-0.24445-1.3992 0.12679-0.36576 0.4205-0.5938 0.36942-1.0106 0.01369-0.44512-0.37032-0.70508-0.49711-1.1019-0.70052-1.6236 1.1037-3.3649 2.7173-2.7364 1.3345 0.51901 1.7604 2.5294 0.6239 3.4506z",
    fill: "none",
    stroke: "#07234a",
    strokeWidth: 0.70052
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeform);
export default __webpack_public_path__ + "static/media/freeform.59d565e1ebc7ef19430e777a779a9c97.svg";
export { ForwardRef as ReactComponent };